webpackJsonp([137990301219821],{

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.uppingthestakes = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(28);
	
	__webpack_require__(31);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _insights_constants = __webpack_require__(25);
	
	var _reactBootstrap = __webpack_require__(22);
	
	var _reactSpinners = __webpack_require__(21);
	
	var _jquery = __webpack_require__(26);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactResponsive = __webpack_require__(23);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	__webpack_require__(10);
	
	var _reactAnimateOnScroll = __webpack_require__(11);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _reactPlayer = __webpack_require__(32);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _sendMailIcon = __webpack_require__(30);
	
	var _sendMailIcon2 = _interopRequireDefault(_sendMailIcon);
	
	var _MailForwardForm = __webpack_require__(27);
	
	var _MailForwardForm2 = _interopRequireDefault(_MailForwardForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/WinPE_ALS2021_linkpreview-03.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide,
	      style: { margin: "0% auto 0px" }
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.post
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item_des" },
	          activeItem.company
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var uppingthestakes = exports.uppingthestakes = function (_React$Component) {
	  _inherits(uppingthestakes, _React$Component);
	
	  function uppingthestakes(args) {
	    _classCallCheck(this, uppingthestakes);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.toggleMailShareForm = function () {
	      _this.setState({ showMailShareForm: !_this.state.showMailShareForm });
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.handleMenu = function (item) {
	      _this.setState({
	        activeTitle: item.title
	      });
	
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      if (item.title === "SORT BY") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else if (item.title === "ALL") {
	        [].concat(leftlist)
	        // .filter((a) => a.r_type === "Appetizer")
	        .forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      } else {
	        [].concat(leftlist).filter(function (insight) {
	          console.log(insight);
	          // a.typee.indexOf(item.title) >= 0}
	          var flag = false;
	          for (var i = 0; i < insight.itype.length; i++) {
	            if (item.title === insight.itype[i]) {
	              flag = true;
	            }
	          }
	          return flag;
	        }).forEach(function (item, i) {
	          return _this.betterContent.push(item);
	        });
	      }
	      _this.setState({
	        activeSortBy: item.title
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.handleSearch = function (e) {
	      var str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
	      _this.setState({
	        isSearching: true,
	        activeKeyword: str
	      });
	      var leftlist = [].concat(_insights_constants.insightsConstants);
	      _this.betterContent = [];
	      leftlist.forEach(function (item) {
	        if (item.skey.toLowerCase().trim().search(str) > -1) {
	          _this.betterContent.push(item);
	        }
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false,
	      activeKeyword: "",
	      isSearching: false,
	      lastCounter: 3,
	      activeTitle: "SORT BY",
	      activeSortBy: "default",
	      showMailShareForm: false
	    };
	
	    _this.betterContent = _insights_constants.insightsConstants;
	    _this.TabContent = [
	    // {
	    // 	title: "POPULARITY",
	    // },
	    {
	      title: "ALL"
	    }, {
	      title: "BLOGS"
	    }, {
	      title: "INFOGRAPHICS"
	    }, {
	      title: "INTERVIEWS"
	    }, {
	      title: "VIDEOS"
	    }];
	    _this.Speaker = [{}];
	    _this.Speaker = [{
	      desc: "<div></div>",
	      name: "",
	      post: "The Alicorn Leadership Summit 2021",
	      imgUrl: icon1,
	      head: "Upping the Stakes"
	    }];
	    _this.SpeakerContent = [{
	      desc: "<div>Gopal Jain is Managing Partner and Co-founder of Gaja Capital (www.gajacapital.com), an India-focused growth & buyout firm based in Mumbai. Founded in 2005, Gaja is a leading player in India\u2019s private equity market with an exceptional track record of 20+ investments and an AUM of over $500m. Gaja has invested consistently in India\u2019s mid-market across themes in education, financial services & consumer. Gaja Capital has been adjudged as the best Indian mid-market PE firm thrice in the last 10 years (Venture Intelligence). Home grown, Gaja Capital is one of the few indigenous PE firms in India to operate at scale.\n        <br/><br/>\n        Gopal leads both the executive and investment functions at the firm and has personally led several of the Firm\u2019s investments. Gopal has been investing in Indian equities since the age of thirteen and has been a professional investor in the Indian capital markets for almost thirty years. He is one of the more experienced private equity investors in India, having led or co-led over 25 private equity investments since his first investment in TV-18 in 1995. Several of the companies Gopal has backed have grown 10x in value since the investment. Prior to Gaja Capital, he was country head for the Boston-based View Group one of the pioneers in Indian private equity.\n        <br/><br/>\n        Gopal is an active columnist and is currently member of SEBI\u2019s Alternative Investment Policy Advisory Committee and Indian Private Equity and Venture Capital Association\u2019s Executive Committee. He has a deep interest in the social sector and leads Gaja Gives which supports a wide and growing number of philanthropic efforts in India.\n        <br/><br/>\n        Gopal is a Graduate in Electrical Engineering from IIT Delhi. He is remembered on the campus for being one of the first graduates from the institute to turn entrepreneur before graduating. He currently lives in Mumbai with his mother Sudesh, wife Chitra and daughters Srishti and Ira.\n        <br/><br/>\n        Gaja Capital\u2019s investments include : Eurokids, RBL Bank, TeamLease & John Distilleries. A longer list is available on their website.</div>",
	      name: "Gopal Jain",
	      company: "Gaja Capital",
	      post: "Managing Partner",
	      fullname: "<div><b>Gopal Jain</b>, Managing Partner, Gaja Capital &nbsp;</div>"
	    }, {
	      desc: "<div>GV Ravishankar is a Managing Director at Sequoia Capital India. At Sequoia, GV Ravishankar advises on both technology as well as non-technology investments. He\u2019s deeply interested in technology\u2019s role in helping to drive efficiencies, reduce costs and improve access in consumer and healthcare markets.\n        <br/><br/>\n        He currently serves on the boards of BYJUs, Capital Float, Eruditus Learning, Faces Cosmetics, Five Star finance, Finova Capital, HomeLane, India Shelter Finance Corporation, Indigo Paints, K12 Technoservices, Prataap Snacks (NSE: DIAMONDYD), Rebel Foods, Rupeek, Suburban Diagnostics and Turtlemint. I have also served as board member/observer of companies like Via (sold to NASDAQ: EBIX ), Manappuram (NSE: MANAPPURAM) and Equitas (NSE: EQUITAS).\n        <br/><br/>\n        Prior to this, GV worked at McKinsey & Company, where he advised senior management of top Indian companies on a variety of issues including business building, channel management and leadership development. He also had a prior stint with Wipro Technologies in their Embedded and Internet Access division.\n        <br/><br/>\n        GV has an MBA from IIMA and holds a BE in Computer Science and Engineering from NIT Trichy. \n\t\t        </div>",
	      name: "GV Ravishankar",
	      company: "Sequoia Capital India",
	      post: "Managing Director",
	      fullname: "<div> <b>GV Ravishankar</b>, Managing Director, Sequoia Capital India</div>"
	    }, {
	      desc: "<div>Harsh is Managing Director at CDPQ, responsible for the externally managed investing program in India. Prior to joining CDPQ, Harsh worked with International Finance Corporation (IFC) in New Delhi. Prior to joining IFC, Harsh has worked with Boston Consulting Group and PriceWaterhouseCoopers, where he worked on diverse topics ranging from investment structuring, M&A and operational improvement in companies.\n        <br/> <br/>\n        Harsh is a fellow member of the Institute of Chartered Accountants of India (Indian CPA) and an MBA from the Indian School of Business, Hyderabad.\n\t\t        </div>",
	      name: "Harsh Singhal",
	      company: "CDPQ India",
	      post: "Managing Director",
	      fullname: "<div><b>Harsh Singhal</b>, Managing Director, CDPQ India &nbsp;</div>"
	    }, {
	      desc: "<div>Janette Hall is a Director in ADB\u2019s Private Sector Operations Department in charge of the Bank\u2019s private equity funds and blended finance program. She joined ADB in January 2011.\n        <br/><br/>\n        Previously, Mrs. Hall was a senior banker in the Investment Banking Group at Bank of America San Francisco as well as in the Corporate Finance Group at KPMG New York, where she focused on mergers, acquisitions, divestitures, restructurings, debt capital raises and public/private equity capital raises. Ms. Hall began her career as an audit associate with Ernst & Young LLP, USA.\n        <br/><br/>\n        Mrs. Hall obtained her bachelor in arts degree from the University of California, Berkeley, Haas School of Business, after which she obtained her MBA from the University of Chicago, Booth School of Business.\n\t\t        </div>",
	      name: "Janette Hall",
	      company: "Asian Development Bank",
	      post: "Director, Investment Funds",
	      fullname: "<div><b>Janette Hall</b>, Director, Investment Funds, Asian Development Bank</div>"
	    }, {
	      desc: "<div> Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. She is the founder of Winpe, a not-for-profit initiative to enhance gender diversity in the investing ecosystem.<br/><br/> Nupur serves as Chairperson of the board of Kids Clinic India Limited and an independent director on the boards of companies including Indigo Paints Limited, Kerala Infrastructure Fund Management Limited and SIDBI, the Indian development finance institution. She is an independent member of the investment committee at the Fund of Funds managed by the National Investment and Infrastructure Fund (NIIF), the quasi sovereign wealth fund sponsored by the government of India, and an advisor to and a member of the investment committee for the Dutch Good Growth Fund (DGGF) investment funds mandate given by the Dutch government for investments in SMEs in frontier markets across 75 countries. She has served as an external expert on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for investing in the Indian start-up ecosystem. Nupur advises select fund managers on a confidential basis on matters related to institutionalization, best practices and governance. She also mentors female entrepreneurs across various platforms. <br/><br/>\n        \n        Nupur was listed in the BW VC World Most Influential Women 2022, Forbes W-Power list of Self Made Women 2020, among India's top 100 Women Leaders in Finance (AIWMI 2019), awarded the Women Empowerment Entrepreneur Award 2019-20 and the Business Excellence and Innovative Best Practices - Academia Award 2019. <br/><br/>\nIn her last and most recent full time role, Nupur led the private equity and venture capital funds business in the region for IFC and is widely credited with establishing IFC's brand and credibility as one of the most respected institutional investors in this space. Under her stewardship, the portfolio doubled in size and returns, moving from a negative IRR to delivering gains for the first time in its history. <br/><br/>Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from Harvard Business School. Nupur loves to spend time with her mother, husband and 6 year-old son, travel to new places, read and do 1000-piece puzzles.\n\t\t        </div>",
	      name: "Nupur Garg",
	      company: "Winpe",
	      post: "Investor & Independent Director, & Founder",
	      fullname: "<div><b>Nupur Garg</b>, Investor & Independent Director, & Founder, Winpe</div>"
	    }, {
	      desc: "<div>Sujoy is a business leader with over three decades of extensive experience in emerging markets investing and project finance, covering infrastructure, industrials and services sectors. During his career, he has worked on projects covering over 50 countries across Asia, Africa, Europe, Middle East, Latin America and the Caribbean.\n        <br/><br/>\n        He joined NIIF as the MD & CEO in 2016 and is currently based in Mumbai.\n        <br/><br/>\n        Prior to joining NIIF, he spent over 25 years at International Finance Corporation (IFC), the private sector investment and financing arm of the World Bank Group. During his tenure at IFC, he has held several leadership positions, with his last position being Director and Global Co-Head, Infrastructure and Natural Resources, based in Washington DC, managing a USD 14 billion portfolio.\n        <br/><br/>\n        Prior to this position, he also served as the Chief Investment Officer and Head of IFC\u2019s African Latin American and Caribbean Fund, based in Washington DC, where he managed and led a USD 1 billion regional growth fund to selectively co-invest with IFC.\n        <br/><br/>\n        From 2006-2010, Sujoy led IFC\u2019s Mumbai office and was responsible for managing its growth and building a strong team of 40 investment professionals as an important part of IFC\u2019s goals for localization of its business. He started his career as a Management Associate with Citibank in Chennai in 1991 as part of the Credit Cards business within the Consumer Banking Group.\n        <br/><br/>\n        Sujoy holds a Bachelor\u2019s in Commerce from St. Xavier\u2019s College, Kolkata, India and is an MBA in Finance from Rice University, Houston, Texas.\n\t\t        </div>",
	      name: "Sujoy Bose",
	      company: "National Investment & Infrastructure Fund",
	      post: "MD & CEO",
	      fullname: "<div><b>Sujoy Bose</b>, MD & CEO, National Investment & Infrastructure Fund</div>"
	    }, {
	      desc: "<div>Vishal Mahadevia is a Managing Director, Head of India, and member of the Executive Management Group. Prior to joining Warburg Pincus in 2006, he was a Principal at Greenbriar Equity Group, a fund focused on private equity investments in the Transportation sector. Prior to that, Mr. Mahadevia worked at Three Cities Research, a New York-based private equity fund and as a consultant with McKinsey & Company. He currently serves as a Managing Director of Warburg Pincus India Private Limited. Mr. Mahadevia is also a Director of Gangavaram Port Limited and IDFC First Bank Limited. He received a B.S. in Economics with a concentration in Finance and a B.S. in Electrical Engineering from the University of Pennsylvania.\n\t\t        </div>",
	      name: "Vishal Mahadevia",
	      company: "Warburg Pincus India",
	      post: "Managing Director",
	      fullname: "<div><b>Vishal Mahadevia</b>, Managing Director, Warburg Pincus India</div>"
	    }];
	    return _this;
	  }
	
	  uppingthestakes.prototype.componentDidMount = function componentDidMount() {
	    // function sticky_relocate () {
	    // 	var window_top = $(window).scrollTop()
	    // 	var div_top = $("#sticky-anchor").offset().top
	    // 	if (window_top > div_top) {
	    // 		$("#sticky").addClass("stick")
	    // 	} else {
	    // 		$("#sticky").removeClass("stick")
	    // 	}
	    // }
	    // $(function () {
	    // 	$(window).scroll(sticky_relocate)
	    // 	sticky_relocate()
	    // })
	    // window.location = "/";
	  };
	
	  uppingthestakes.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isSearching = _state.isSearching,
	        isShow = _state.isShow,
	        activeTitle = _state.activeTitle,
	        activeSortBy = _state.activeSortBy;
	    var location = this.props.location;
	    // return null;
	
	    var leftList = this.betterContent.filter(function (item) {
	      return item.url !== "/uppingthestakes";
	    });
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_MailForwardForm2.default, {
	        show: this.state.showMailShareForm,
	        onClickClose: this.toggleMailShareForm,
	        url: "insights.php/forward",
	        insight: "Upping the Stakes"
	      }),
	      _react2.default.createElement(
	        _contentPage2.default,
	        null,
	        _react2.default.createElement(_meta2.default, {
	          title: "Winpe Insights | Upping the Stakes",
	          image: "https://winpeforum.com/assets/elements/uppingthestakes_linkpreview.jpg",
	          description: "Upping the Stakes, a forum for a candid and open dialogue between fund managers and investors for gender diversity.",
	          location: location
	        }),
	        _react2.default.createElement(_meta2.default, {
	          title: "Winpe Insights | Upping the Stakes",
	          image: "https://winpeforum.com/assets/elements/uppingthestakes_linkpreview.jpg",
	          description: "Upping the Stakes, a forum for a candid and open dialogue between fund managers and investors for gender diversity.",
	          location: location
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "section__content" },
	          _react2.default.createElement(
	            "div",
	            { className: "insights_wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "insights_section" },
	              _react2.default.createElement(
	                _reactResponsive2.default,
	                { query: "(min-width: 768px)" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights_main_heading" },
	                  _react2.default.createElement("div", { className: "left_line" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "insights_main_heading_text" },
	                    "Winpe INSIGHTS"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactResponsive2.default,
	                {
	                  query: "(min-width: 767px)",
	                  style: { display: "none" }
	                },
	                _react2.default.createElement("div", { className: "insights_main_heading" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "insights_content" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "drop_src_box" },
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { query: "(min-width: 768px)" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_drop_box" },
	                      _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { title: activeTitle },
	                        this.TabContent.map(function (item, j) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            {
	                              onClick: function onClick() {
	                                return _this2.handleMenu(item);
	                              },
	                              activeSortBy: activeSortBy,
	                              text: item.title,
	                              key: j
	                            },
	                            item.title
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    {
	                      query: "(max-width: 767px)",
	                      style: { display: "none" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_drop_box" },
	                      _react2.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { title: activeTitle },
	                        this.TabContent.map(function (item, j) {
	                          return _react2.default.createElement(
	                            _reactBootstrap.MenuItem,
	                            {
	                              onClick: function onClick() {
	                                return _this2.handleMenu(item);
	                              },
	                              activeSortBy: activeSortBy,
	                              text: item.title,
	                              key: j
	                            },
	                            item.title
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { query: "(min-width: 768px)" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "left_scr_box" },
	                      _react2.default.createElement(
	                        "form",
	                        { id: "demo-2" },
	                        _react2.default.createElement("input", {
	                          type: "search",
	                          placeholder: "Search",
	                          onChange: function onChange(e) {
	                            return _this2.handleSearch(e);
	                          },
	                          value: this.state.activeKeyword
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactResponsive2.default,
	                    {
	                      query: "(max-width: 767px)",
	                      style: { display: "none" }
	                    },
	                    _react2.default.createElement("div", { className: "left_scr_box" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights_mid_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      _reactResponsive2.default,
	                      { query: "(min-width: 768px)" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-3 col-md-3" },
	                        _react2.default.createElement("div", { id: "sticky-anchor" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights_left_listing" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights_left_listing_text" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "left_listing_card left_listing_card--feature" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t1" },
	                                _react2.default.createElement(
	                                  "span",
	                                  null,
	                                  "Video\xA0"
	                                ),
	                                "\u2022 21 January 2021"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t2" },
	                                "Upping the Stakes"
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "listing_t3" },
	                                "Alicorn Leadership Summit 2021"
	                              )
	                            ),
	                            isSearching ? _react2.default.createElement(
	                              "div",
	                              { style: { margin: "10% 25% 10%" } },
	                              _react2.default.createElement(_reactSpinners.ClipLoader, {
	                                color: "#22316B",
	                                loading: isSearching
	                              })
	                            ) : leftList.length ? leftList.slice(0, 27).map(function (item, i) {
	                              return _react2.default.createElement(
	                                "div",
	                                { className: "left_listing_card", key: i },
	                                _react2.default.createElement(
	                                  _gatsbyLink2.default,
	                                  {
	                                    to: "/insights/" + item.url.replace(/[^A-Z0-9]+/gi, "")
	                                  },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t1" },
	                                    _react2.default.createElement(
	                                      "span",
	                                      null,
	                                      item.type,
	                                      "\xA0"
	                                    ),
	                                    "\u2022 ",
	                                    item.date
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t2" },
	                                    item.ltitle
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_t3" },
	                                    item.lname
	                                  )
	                                )
	                              );
	                            }) : _react2.default.createElement(
	                              "div",
	                              { className: "no__product" },
	                              "Not available in the list"
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactResponsive2.default,
	                      {
	                        query: "(max-width: 767px)",
	                        style: { display: "none" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-3 col-md-3" },
	                        _react2.default.createElement("div", { id: "sticky-anchor" }),
	                        _react2.default.createElement("div", { className: "insights_left_listing" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-9 col-md-9" },
	                      _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                          delay: 0,
	                          duration: 2,
	                          animateIn: "slideInRight",
	                          offset: 600
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights_right_text" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights_blog_page" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "back_event" },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: "/insights" },
	                                _react2.default.createElement(
	                                  "i",
	                                  { className: "fa fa-arrow-left" },
	                                  " ",
	                                  "browse Insights"
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text" },
	                              this.Speaker.map(function (item, i) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  { className: "row" },
	                                  _react2.default.createElement(
	                                    _reactAnimateOnScroll2.default,
	                                    {
	                                      delay: 0,
	                                      duration: 1,
	                                      animateIn: "zoomIn",
	                                      offset: 100
	                                    },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-4 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "right_img_section" },
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            href: "http://alicornsummit.winpeforum.com/",
	                                            target: "_blank"
	                                          },
	                                          _react2.default.createElement("img", {
	                                            src: item.imgUrl,
	                                            alt: "nupur_garg",
	                                            className: "img-responsive"
	                                          })
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "col-md-8 col-sm-6" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "right_name_section" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_head" },
	                                          "Upping the Stakes"
	                                        ),
	                                        _react2.default.createElement("div", { className: "r_name" }),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_post" },
	                                          "The Alicorn Leadership Summit 2021 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0"
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "r_block" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "VIDEO"
	                                          ),
	                                          " \u2022 1.5 hour video"
	                                        )
	                                      ),
	                                      _react2.default.createElement(
	                                        "div",
	                                        { className: "share_section_one" },
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "headsocialLink" },
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                href: "https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: "",
	                                                style: {
	                                                  display: "block !important"
	                                                }
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/SM_icon_01_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                style: {
	                                                  display: "block !important"
	                                                },
	                                                href: "https://twitter.com/intent/tweet?url=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: ""
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/SM_icon_02_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "a",
	                                              {
	                                                style: {
	                                                  display: "block !important"
	                                                },
	                                                href: "https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com" + location.pathname,
	                                                target: "_blank",
	                                                className: ""
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: "https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png",
	                                                alt: ""
	                                              })
	                                            )
	                                          ),
	                                          _react2.default.createElement(
	                                            "span",
	                                            { className: "hicon" },
	                                            _react2.default.createElement(
	                                              "button",
	                                              {
	                                                style: {
	                                                  width: "25px"
	                                                },
	                                                className: "forwardMail",
	                                                title: "Forward to email",
	                                                onClick: _this2.toggleMailShareForm
	                                              },
	                                              _react2.default.createElement("img", {
	                                                src: _sendMailIcon2.default,
	                                                alt: ""
	                                              })
	                                            )
	                                          )
	                                        )
	                                      )
	                                    )
	                                  )
	                                );
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "insights_blog_text_btm" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "text_section" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "into_text" },
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "dis_line" },
	                                    "Upping the Stakes is a forum for a candid and open dialogue between LPs and GPs on gender diversity featuring:",
	                                    " "
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "dis_line" },
	                                    _react2.default.createElement(
	                                      "ul",
	                                      { style: { marginBottom: "0px" } },
	                                      this.SpeakerContent.map(function (item, i) {
	                                        return _react2.default.createElement(
	                                          "li",
	                                          null,
	                                          _react2.default.createElement("span", {
	                                            className: "dis_line",
	                                            dangerouslySetInnerHTML: {
	                                              __html: item.fullname
	                                            },
	                                            onClick: function onClick() {
	                                              return _this2.togglePopUp(item);
	                                            }
	                                          })
	                                        );
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "dis_line" },
	                                    "Hear from industry leaders as they take stock of the state of gender diversity in the private equity/ venture capital ecosystem, share the progress made, and deliberate upon the way forward to building gender balance in investing and entrepreneurism."
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "interview_vieo_section" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "interview_video" },
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "video_text" },
	                                      "\u201CThe Alicorn Leadership Summit is a special series of events celebrating the power of gender diversity and marking Winpe's first anniversary.\u201D"
	                                    ),
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "video_text" },
	                                      "\u201CGender diversity to me means sustainability. Having a diverse leadership team is a great risk mitigator.\u201D"
	                                    ),
	                                    " ",
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "video_text" },
	                                      "\u201CThe biggest challenge for gender diversity is in implementation. A lot of firms and institutions want to do the right thing and have the policies in place, but just do not have the resources to track gender diversity. So if you equip them with resources you will see a lot more happening than just putting lipstick on the cover and walking away.\u201D"
	                                    ),
	                                    " ",
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "video_text" },
	                                      "\u201CWe are using a scorecard approach for key parameters of diversity. In our due diligence of GPs, we will be bringing this to action.\u201D"
	                                    ),
	                                    " ",
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "video_text" },
	                                      "\u201CGender diversity to me is opportunity. It is an extraordinary opportunity for us to benefit from extraordinary talent that we are not utilizing well enough yet.\u201D"
	                                    ),
	                                    " ",
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "video_text" },
	                                      "\u201CAs an industry, we have a problem- it is staring us in the face. Supporting efforts to help solve it and come up with innovative ways to do it is all of our responsibility. I would encourage all of our peers to join Winpe and solve the gender diversity problem as a responsibility to the industry.\u201D"
	                                    ),
	                                    _react2.default.createElement(
	                                      "div",
	                                      { className: "video_css1" },
	                                      _react2.default.createElement(_reactPlayer2.default, {
	                                        width: "100%",
	                                        height: "100%",
	                                        style: {
	                                          margin: "0 auto",
	                                          padding: "0",
	                                          borderRadius: "0px",
	                                          background: "#000000",
	                                          cursor: "pointer"
	                                        },
	                                        controls: !!true,
	                                        url: "https://www.youtube.com/watch?v=xV6uH_3UJpw",
	                                        playing: false
	                                      })
	                                    )
	                                  )
	                                ),
	                                _react2.default.createElement("div", { className: "r_text_Q" }),
	                                _react2.default.createElement("div", { className: "r_text_Q" }),
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "r_text" },
	                                  _react2.default.createElement("div", {
	                                    className: "para",
	                                    style: { padding: "20px 0px 0px 0px" }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "footer_sm_icon" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "headsocialLink" },
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        href: "https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: "",
	                                        style: { display: "block !important" }
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/SM_icon_01_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        style: { display: "block !important" },
	                                        href: "https://twitter.com/intent/tweet?url=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: ""
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/SM_icon_02_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "a",
	                                      {
	                                        style: { display: "block !important" },
	                                        href: "https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com" + location.pathname,
	                                        target: "_blank",
	                                        className: ""
	                                      },
	                                      _react2.default.createElement("img", {
	                                        src: "https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png",
	                                        alt: ""
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "span",
	                                    { className: "hicon" },
	                                    _react2.default.createElement(
	                                      "button",
	                                      {
	                                        style: {
	                                          // display: "none",
	                                          width: "25px"
	                                        },
	                                        className: "forwardMail",
	                                        title: "Forward to email",
	                                        onClick: this.toggleMailShareForm
	                                      },
	                                      _react2.default.createElement("img", { src: _sendMailIcon2.default, alt: "" })
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "back_event" },
	                              _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: "/insights" },
	                                _react2.default.createElement(
	                                  "i",
	                                  { className: "fa fa-arrow-left" },
	                                  " ",
	                                  "browse Insights"
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(TeamModal, {
	              show: isShow,
	              onHide: this.togglePopUp,
	              activeItem: this.state.activeItem
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return uppingthestakes;
	}(_react2.default.Component);
	
	uppingthestakes.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = uppingthestakes;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-insights-uppingthestakes-js-b1a63f59d15fdd06c5ee.js